import React from 'react';
import { Section } from './Section';
import { Check, X } from 'lucide-react';
export const ParaQuien = () => {
  const esPara = ['Mujeres que trabajan en oficinas, bancos, hospitales o escuelas con mucha carga emocional.', "Profesionales que sienten que 'el aire se corta con tijera' en sus reuniones.", 'Aquellas que llegan a casa y no tienen energía ni para cocinar o jugar con sus hijos.', 'Freelancers que trabajan en coworkings y sienten que absorben el caos ajeno.'];
  const noEsPara = ['Personas que buscan una solución mágica sin hacer los ejercicios de visualización.', 'Quienes prefieren seguir instaladas en la queja en lugar de tomar acción sobre su bienestar.'];
  return <Section data-id="element-177">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-178">
        {/* Es para */}
        <div className="p-8 border border-gold/30 bg-navy-900/40 rounded-sm relative" data-id="element-179">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-navy-800 px-6 py-2 border border-gold/30 rounded-full" data-id="element-180">
            <h3 className="font-serif text-xl text-gold" data-id="element-181">Para quién ES esto</h3>
          </div>
          <ul className="mt-8 space-y-6" data-id="element-182">
            {esPara.map((text, i) => <li key={i} className="flex gap-4 items-start" data-id="element-183">
                <div className="mt-1 p-1 rounded-full bg-gold/20 text-gold shrink-0" data-id="element-184">
                  <Check size={16} strokeWidth={3} data-id="element-185" />
                </div>
                <p className="text-gray-300 font-light" data-id="element-186">{text}</p>
              </li>)}
          </ul>
        </div>

        {/* No es para */}
        <div className="p-8 border border-navy-700 bg-navy-900/20 rounded-sm relative opacity-80" data-id="element-187">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-navy-800 px-6 py-2 border border-navy-600 rounded-full" data-id="element-188">
            <h3 className="font-serif text-xl text-gray-400" data-id="element-189">
              Para quién NO es
            </h3>
          </div>
          <ul className="mt-8 space-y-6" data-id="element-190">
            {noEsPara.map((text, i) => <li key={i} className="flex gap-4 items-start" data-id="element-191">
                <div className="mt-1 p-1 rounded-full bg-navy-700 text-gray-500 shrink-0" data-id="element-192">
                  <X size={16} strokeWidth={3} data-id="element-193" />
                </div>
                <p className="text-gray-400 font-light" data-id="element-194">{text}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
};